import { FC } from "react";
import { TimePickerPopup, formStyles } from "shared/ui";
import {
  DURATION_PRESETS,
  adjustDuration,
  clampToLimits,
  formatDurationLimits,
  splitDuration,
} from "../model/duration";
import type { DurationLimits } from "../model/duration";
import { LabeledInput } from "./LabeledInput";

import styles from "./CreateWheelRaffleForm.module.css";

interface Props {
  value: number;
  limits: DurationLimits;
  error?: string;
  onChange: (seconds: number) => void;
}

// Тот же пикер ±ч/±мин/±сек, что у экспирации сделки.
export const DurationField: FC<Props> = ({
  value,
  limits,
  error,
  onChange,
}) => (
  <LabeledInput
    label="Duration"
    hint={`Starts right away, lasts ${formatDurationLimits(limits)}.`}
  >
    <div
      className={`${formStyles.input} ${styles.duration} ${error ? formStyles.inputInvalid : ""}`}
    >
      <TimePickerPopup
        {...splitDuration(value)}
        duration={value}
        presets={DURATION_PRESETS}
        onAdjust={(field, delta) =>
          onChange(adjustDuration(value, field, delta, limits))
        }
        onSelectPreset={(preset) => onChange(clampToLimits(preset, limits))}
      />
    </div>
    {error && <span className={formStyles.error}>{error}</span>}
  </LabeledInput>
);
